import React from 'react';

import type {ConfigV2} from '../../util/runfeed';
import {RunsAutoCols} from './RunsAutoCols';
import {RunsDownloadMenu} from './RunsDownloadMenu';
import type {RunSelectorRunsPartialVars} from './types';
import {WBTableColumn} from './WBTable/types';

type RunsSelectorExtraTableActionsRightProps = {
  columns: WBTableColumn[];
  currentPage: number;
  disabledFeatures: Record<string, boolean>;
  isInReport: boolean;
  setTableSettings: (settings: any) => void;
  tableSettings: ConfigV2;
  topLevelQueryVariables: RunSelectorRunsPartialVars;
};

export function RunSelectorExtraTableActionsRight(
  props: RunsSelectorExtraTableActionsRightProps
) {
  return (
    <>
      {!props.disabledFeatures?.export && (
        <RunsDownloadMenu
          pageQuery={props.topLevelQueryVariables}
          tableSettings={props.tableSettings}
        />
      )}
      {!props.disabledFeatures?.['auto-cols'] && (
        <RunsAutoCols
          query={props.topLevelQueryVariables}
          tableSettings={props.tableSettings}
          isInReport={props.isInReport}
          setTableSettings={props.setTableSettings}
          currentPage={props.currentPage}
          columns={props.columns}
        />
      )}
    </>
  );
}
